<template>
  <v-app>
    <Navbar/>
    <router-view />
    <v-layout class="grid grid-one light-bg text-center footer" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out" style="background:white">
      <!-- <h3>- - - - - - - - - - - - - - - - - - - - -</h3>
        <h3>Vi har för tillfällande problem med vår fasta telefoni. Vi nås lättast via info@smartasystem.se.</h3>
        <h3>- - - - - - - - - - - - - - - - - - - - -</h3><br><br> -->
      <img src="./assets/imgs/logo.png" alt="">
      <p>Smarta System Norden AB, Sundstorget 3, 252 21 Helsingborg<br>

Tfn: 042-27 00 15, E-post: info@smartasystem.se<br>

©2020 — Smarta System Norden AB</p>
    </v-layout>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      //
    }
  }
}
</script>
